import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-kamalpreet',
  templateUrl: './kamalpreet.component.html',
  styleUrls: ['./kamalpreet.component.scss']
})
export class KamalpreetComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getKamal();
  }

}
